import { SelectProps } from "antd";
import { useContext, useMemo } from "react";

import SOrgSelect from "@/components/SOrgSelect";
import { DictContext } from "@/layout/context/DictContext";
import { CellSelectWrap } from "./style";
import SText from "@/styles/SText";

interface DepartmentSelectProps extends SelectProps {
  value?: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
  allowClear?: boolean
}

const DepartmentSelect = ({
  value,
  onChange,
  readOnly,
  allowClear
}: DepartmentSelectProps) => {
  const { orgs } = useContext(DictContext);
  const realVal = useMemo(() => {
    if (orgs && !!orgs.find(o => o.id === value)) return value
    else return undefined
  }, [value, orgs])
  if (readOnly) {
    return <SText text={orgs.find(item => item.id === value)?.name ?? ''} />;
  }

  return (
    <CellSelectWrap>
      <SOrgSelect list={orgs} value={realVal} onChange={onChange} disabled={readOnly} allowClear={allowClear} />
    </CellSelectWrap>
  );
};

export default DepartmentSelect;
